module.exports = __webpack_public_path__ + "img/icon_eyes.d2e19128.svg";